<template>
  <b-container id="view" style="padding: 0">
    <Navbar></Navbar>
    <b-container style="padding-top: 10px; padding-bottom: 30px">
      <div class="selector_course">
        <b-button v-for="(course, index) in $store.state.list_courses" :key="index" @click="selected = course.anchor" :class="[selected == course.anchor ? 'selected' : '']">{{ course.name }}</b-button>
      </div>
      <PresentationCastillon v-if="selected == 'castillon'" :course="selected_course"></PresentationCastillon>
      <PresentationPontsbleus v-if="selected == 'ponts'" :course="selected_course"></PresentationPontsbleus>
      <PresentationValtrede v-if="selected == 'valtrede'" :course="selected_course"></PresentationValtrede>
      <PresentationSixCollines v-if="selected == 'collines'" :course="selected_course"></PresentationSixCollines>
      <PresentationCalanquaise v-if="selected == 'calanquaise'" :course="selected_course"></PresentationCalanquaise>
      <PresentationCalanques v-if="selected == 'calanques'" :course="selected_course"></PresentationCalanques>
      <PresentationDraille v-if="selected == 'draille'" :course="selected_course"></PresentationDraille>
      <PresentationTouloubre v-if="selected == 'touloubre'" :course="selected_course"></PresentationTouloubre>
      <PresentationEmbruns v-if="selected == 'embruns'" :course="selected_course"></PresentationEmbruns>
      <PresentationMarignanaise v-if="selected == 'etangs'" :course="selected_course"></PresentationMarignanaise>
      <PresentationCarroCarry v-if="selected == 'carro'" :course="selected_course"></PresentationCarroCarry>
      <PresentationMartigues v-if="selected == 'martigues'" :course="selected_course"></PresentationMartigues>
      <PresentationRunByNight v-if="selected == 'night'" :course="selected_course"></PresentationRunByNight>
      <PresentationEscapade v-if="selected == 'escapade'" :course="selected_course"></PresentationEscapade>
      <PresentationSeinche v-if="selected == 'seinche'" :course="selected_course"></PresentationSeinche>
      <PresentationPelissanaises v-if="selected == 'pelissanaises'" :course="selected_course"></PresentationPelissanaises>
    </b-container>
    <p style="font-size: 12px; padding-bottom: 10px; text-align: center">
      <b>Généré par </b> <a href="https://sportips.fr" target="_blank"><img src="https://sportips.fr/ressources/logo_menu.png" style="display: inline; width: 80px" /></a>
    </p>
  </b-container>
</template>

<script>
import Navbar from "../components/Navbar.vue";
import PresentationCastillon from "../components/Courses/Castillon.vue";
import PresentationPontsbleus from "../components/Courses/PontsBleus.vue";
import PresentationValtrede from "../components/Courses/Valtrede.vue";
import PresentationSixCollines from "../components/Courses/SixCollines.vue";
import PresentationCalanquaise from "../components/Courses/Calanquaise.vue";
import PresentationCalanques from "../components/Courses/Calanques.vue";
import PresentationDraille from "../components/Courses/Draille.vue";
import PresentationTouloubre from "../components/Courses/Touloubre.vue";
import PresentationEmbruns from "../components/Courses/Embruns.vue";
import PresentationMarignanaise from "../components/Courses/Marignanaise.vue";
import PresentationCarroCarry from "../components/Courses/CarroCarry.vue";
import PresentationMartigues from "../components/Courses/Martigues.vue";
import PresentationRunByNight from "../components/Courses/RunByNight.vue";
import PresentationEscapade from "../components/Courses/Escapade.vue";
import PresentationSeinche from "../components/Courses/Seinche.vue";
import PresentationPelissanaises from "../components/Courses/Pelissanaises.vue";

export default {
  components: {
    Navbar,
    PresentationCastillon,
    PresentationPontsbleus,
    PresentationValtrede,
    PresentationSixCollines,
    PresentationCalanquaise,
    PresentationCalanques,
    PresentationDraille,
    PresentationTouloubre,
    PresentationEmbruns,
    PresentationMarignanaise,
    PresentationCarroCarry,
    PresentationMartigues,
    PresentationRunByNight,
    PresentationEscapade,
    PresentationSeinche,
    PresentationPelissanaises,
  },
  data() {
    return {
      selected: "castillon",
    };
  },
  computed: {
    selected_course() {
      return this.$store.state.list_courses.find((course) => course.anchor == this.selected);
    },
  },
};
</script>

<style lang="scss">
.selector_course {
  display: flex;
  flex-direction: row;
  justify-content: center;
  flex-wrap: wrap;
  button {
    background-color: #1c2681;
    border-radius: 0;
    border: 0;
    font-size: 11px;
    &.selected,
    &:hover {
      background-color: #7f95d1;
    }
  }
}
</style>
